import React from 'react';

import { Comments } from '~/components/ContractDetails/Comments';

import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type ContractCommentsViewProps = {
  contractId: string;
  // eslint-disable-next-line react/no-unused-prop-types
  contractIds: string[];
  // eslint-disable-next-line react/no-unused-prop-types
  loading: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  contractDetails: any;
  onBack: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  onContractChange: (id: string) => void;
};

export function ContractCommentsView({ contractId, onBack }: ContractCommentsViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <Comments contractId={contractId} />
    </div>
  );
}
